import { QUESTS_ACTIONS } from '../Actions/questsActions';
import { QUESTS, getNextQuest } from '../../Helpers/quests';

const QUESTS_INITIAL_STATE = {
    active: 'awakening',
    progress: {
        awakening: {
            currentStep: QUESTS.awakening.startStep,
            counters: {},
        },
    },
    completed: [],
};

export const questsReducer = (state = QUESTS_INITIAL_STATE, action) => {
    switch (action.type) {
        case QUESTS_ACTIONS.INIT: {
            const nextActive = getNextQuest([]);
            if (!nextActive) return state;
            return {
                active: nextActive,
                progress: {
                    [nextActive]: { currentStep: QUESTS[nextActive].startStep, counters: {} },
                },
                completed: [],
            };
        }

        case QUESTS_ACTIONS.ADVANCE_STEP: {
            const { questId, nextStep } = action.payload;
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [questId]: {
                        ...(state.progress[questId] || { counters: {} }),
                        currentStep: nextStep,
                    },
                },
            };
        }

        case QUESTS_ACTIONS.INCREMENT_COUNTER: {
            const { questId, counterKey, by = 1 } = action.payload;
            const prev = state.progress[questId] || { currentStep: null, counters: {} };
            return {
                ...state,
                progress: {
                    ...state.progress,
                    [questId]: {
                        ...prev,
                        counters: {
                            ...prev.counters,
                            [counterKey]: (prev.counters[counterKey] || 0) + by,
                        },
                    },
                },
            };
        }

        case QUESTS_ACTIONS.COMPLETE_QUEST: {
            const { questId } = action.payload;
            const completed = [...state.completed, questId];
            const nextActive = getNextQuest(completed);
            const nextProgress = { ...state.progress };
            if (nextActive && !nextProgress[nextActive]) {
                nextProgress[nextActive] = { currentStep: QUESTS[nextActive].startStep, counters: {} };
            }
            return {
                ...state,
                active: nextActive,
                completed,
                progress: nextProgress,
            };
        }

        default:
            return state;
    }
};

export default questsReducer;
